export default __webpack_public_path__ + "static/media/timeseries.8fe470d1.gif";